import { render, staticRenderFns } from "./LanguageSelectDropdown.vue?vue&type=template&id=7c8d115e&scoped=true&"
import script from "./LanguageSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectDropdown.vue?vue&type=style&index=0&id=7c8d115e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d115e",
  null
  
)

export default component.exports